// src/fromQueryString.ts
function fromQueryString(string) {
	if (!string) return {};
	if (string.charAt(0) === "?" || string.charAt(0) === "#") return fromQueryString(string.substring(1));
	return string.split("&").reduce((hash, part) => {
		const [key, value] = part.split("=");
		hash[key] = decodeURIComponent(value ?? "");
		return hash;
	}, {});
}
export { fromQueryString };

//# sourceMappingURL=fromQueryString.js.map